import React from 'react';

import backImg from '../../images/back.png';
import history from '../../history';

const ManageDoaHeader = ({ text, onEdit, isEdit, onOpenRef, onCloseRef}) => {
    const onBackPressed = () => {
        history.goBack();
    }

    return (
        <div>
            <div className="flex-h pr-16 pl-16 pt-8 pb-8 bg-red">
                <img onClick={() => onBackPressed()} className="mt-8 mb-8" style={{ height: '24px', cursor: 'pointer' }} src={backImg} alt="" />
                <div className="flex-v flex-center flex-1">
                    <h3 className="has-text-white-bis mr-24">{text}</h3>
                </div>
                <div className="flex-h flex-center">
                    {isEdit && <button onClick={() => onOpenRef()} className="button is-small is-primary">Reference</button>}
                    {isEdit && <button onClick={() => onEdit()} className="ml-8 button is-small is-success">Checkout</button>}
                </div>
            </div>
            <div className="flex-h">
                <div className="flex-1" style={{ backgroundColor: '#ff3a42', height: '4px' }}></div>
                <div className="flex-1" style={{ backgroundColor: '#fcae00', height: '4px' }}></div>
                <div className="flex-1" style={{ backgroundColor: '#282e43', height: '4px' }}></div>
                <div className="flex-1" style={{ backgroundColor: '#00cfe3', height: '4px' }}></div>
            </div>
        </div>
    )
}

export default ManageDoaHeader